<div class="flex flex-row justify-center items-center text-green">
  <ng-content></ng-content>
</div>
